<template>
  <div class="my-info-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">

      <div class="my-info-box">
        <div class="title">我的信息</div>

        <div class="form">
          <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
            <el-form-item label="手机号" prop="user_name">
              {{ form.user_name }}
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>

            <el-form-item label="姓名" prop="real_name">
              <el-input v-model="form.real_name"></el-input>
            </el-form-item>

            <el-form-item label="所在学校" prop="company_id">
              <el-select disabled class="companySelect" v-model="form.company_id" placeholder="所在学校">
                <el-option
                  v-for="item in schoolList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>

            </el-form-item>

            <el-form-item label="担任职务" prop="position">
              <el-input placeholder="担任职务" v-model.trim="form.position"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="userSubmit" type="primary">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { updateUserInfo, getUserInfo } from '@/api/login'
import { fetchSchoolList } from '@/api/common'
import { getMobile } from '@/utils/auth'
import { isMobile } from '@/utils/index'

const checkEmail = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }

  if (!(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value))) {
    return callback(new Error('您输入的邮箱不合法'))
  }

  callback()
}

export default {
  data() {
    return {


      form: {
        user_name: '',
        email: '',

        real_name: '',
        company_id: "",
        position: ""
      },
      formRules: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],

        // real_name: [
        //   { required: true, message: '姓名为必填项', trigger: 'blur' },
        //   { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        // ],
        // companyId: [
        //   { required: true, message: '学校为必选项', trigger: 'blur' },
        // ],
        // position: [
        //   { required: true, message: '职位为必填项', trigger: 'blur' },
        //   { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        // ]
      },

      schoolList: [],

      loading: false
    }
  },
  mounted() {

  },
  methods: {
    isMobile,
    async getSchoolList() {
      try {
        this.schoolList = await fetchSchoolList({
          page: 0,
          pageSize: 999 // TODO:
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getUserInfo() {
      try {
        const data = await getUserInfo()

        for (const key in this.form) {
          this.form[key] = data[key]
        }
      } catch (error) {
        console.log(error)
      }
    },

    

    userSubmit() { // 编辑提交

      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true

          const { email, real_name, position } = this.form

          let params = {
            email,
            real_name,
            position
          }

          try {
            await updateUserInfo(params)

            this.loading = false

            this.$message.success('操作成功')
            this.getUserInfo()
          } catch (error) {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
  },
  created() {
    this.getSchoolList()
    this.getUserInfo()
  }
}
</script>

<style lang="scss">
.my-info-container {
  background: $bg;

  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;
      .my-info-box {
        padding: 2rem 1.5rem;
        .title {
          margin-bottom: 2.5rem;
        }
        .form {
          width: inherit;
        }
      }
    }
  }

  .sys-max-width {
    padding: 49px 0px 71px;

    .my-info-box {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
      border-radius: 10px;
      padding: 46px 52px 82px;

      .title {
        font-size: 20px;
        font-weight: 400;
        color: #596270;
        line-height: 24px;
        margin-bottom: 74px;
      }

      .form {
        margin: 0 auto;
        width: 400px;
      }

    }

    .companySelect {
      width: 100%;
    }

    .code-item {
      margin-bottom: 22px;
      .el-form-item__content {
        display: flex;
        justify-content: space-between;
      }

      .el-button {
        width: 110px;
        margin-left: 10px;
      }
    }


  }
}
</style>
